module.exports = __webpack_public_path__ + "static/img/icon-no-seat.907eddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icon-no-seat.png
// module id = 1017
// module chunks = 34